class GoogleMapsSuburbAutocomplete {
    /**
     * Creates a Google Maps Places Autocomplete field filtered to Australian suburbs.
     * @param {HTMLInputElement} inputElement - The input element to attach autocomplete to.
     * @param {function} [onPlaceChanged] - Optional callback when a place is selected.
     */
    constructor(inputElement, onPlaceChanged) {
        this.inputElement = inputElement;
        this.onPlaceChanged = onPlaceChanged;

        if (
            !window.google ||
            !window.google.maps ||
            !window.google.maps.places
        ) {
            // Maps API isn't ready — bail out quietly. Callers are expected to wait
            // for `window.google.maps.places` before instantiating this class.
            // eslint-disable-next-line no-console
            console.warn(
                'GoogleMapsSuburbAutocomplete: Google Maps Places API not loaded; skipping init.',
            );
            return;
        }

        this.autocomplete = new google.maps.places.Autocomplete(inputElement, {
            fields: ['address_components', 'geometry'],
            componentRestrictions: { country: 'au' },
        });

        this.addEvents();
    }

    /**
     * Returns the underlying Autocomplete instance.
     */
    getInstance() {
        return this.autocomplete;
    }

    /**
     * Adds event listeners to handle autocomplete interactions.
     * - Prevents form submission when selecting an autocomplete option with the Enter key.
     * - Handles Enter key behavior for both the autocomplete widget and the native input element,
     *   ensuring consistent UX across browsers.
     *
     * @returns {void}
     */
    addEvents() {
        // Prevent submit when selecting autocomplete option
        this.autocomplete.addListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
            }
        });

        // Also handle the native input event for some browsers
        this.inputElement.addEventListener('keydown', (e) => {
            if (
                e.key === 'Enter' &&
                document.activeElement === this.inputElement &&
                document.querySelector('.pac-item-selected')
            ) {
                e.preventDefault();
            }
        });

        if (typeof this.onPlaceChanged === 'function') {
            this.autocomplete.addListener('place_changed', () => {
                this.onPlaceChanged(this.autocomplete.getPlace());
            });
        }
    }
}

export default GoogleMapsSuburbAutocomplete;
